import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { analytics, ANALYTICS_SUBPRODUCT_PARTNER_CENTRAL } from '@atlassian/temp-analytics';
import { initSentryClient } from './sentry';
import route from './routes';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store/store';

initSentryClient();

//TODO: this should be partner central, also we need to register PPC first for analytics. Please comment this with a TODO and a Jira tkt https://hello.atlassian.net/browse/ITFO-4104
analytics.setSubproduct(ANALYTICS_SUBPRODUCT_PARTNER_CENTRAL);

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>{route}</BrowserRouter>
    </Provider>
  </StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
